import { debounce } from 'lodash';

import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';

const EVENTS_TYPE = 'events';

export const getFiltersAppConfig = ({
  setFilters,
  isFixedToLeft,
  handleLocationFilterChange,
  topicId,
  currentUser,
  topicContext,
}) => ({
  type: EVENTS_TYPE,
  handleFiltersUpdate: debounce((filters, totalSelectedMoreFilters) => {
    setFilters({ filters, totalSelectedMoreFilters });
  }, 200),
  handleLocationFilterChange,
  ignoredParamsKeys: [],
  initialFilters: {},
  isFixedToLeft,
  filters_path: currentUser
    ? Routes.search_filters_path({
        type: EVENTS_TYPE,
        topic_id: topicId,
      })
    : dynamicTopicResourcePath(
        Routes.search_filters_po_path({
          type: EVENTS_TYPE,
          topic_id: topicId,
        }),
        topicContext,
      ),
});
